import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { isEqual } from "lodash"

import { GET_PARCELS } from "data/constants"
import { clearParcels } from "data/actions/parcels"

import Loader from "shared/components/Loader/Local"

import ParcelsList from "./components/ParcelsList/ParcelsList"

class Parcels extends Component {
  static propTypes ={
    location: PropTypes.object.isRequired,
    state: PropTypes.oneOf(["INITIAL", "LOADING", "LOADED", "FAILED"]).isRequired,
    get: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    parcelsList: PropTypes.array.isRequired,
    errorsList: PropTypes.array.isRequired,
  }

  componentDidMount() {
    this.fetch()
  }

  componentWillUpdate(prevProps) {
    const { clear, location } = this.props

    if (!isEqual(prevProps.location.query.id, location.query.id)) {
      clear()
    }
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props

    if (!isEqual(prevProps.location.query.id, location.query.id)) {
      this.fetch()
    }
  }

  fetch() {
    const { get, location } = this.props
    get(location.query.id)
  }

  renderParcelsList(parcelsList, errorsList) {
    return <ParcelsList parcelsList={parcelsList} errorsList={errorsList} />
  }

  render() {
    const { state, parcelsList, errorsList } = this.props

    switch (state) {
      case "LOADING":
        return <Loader />
      case "LOADED":
        return this.renderParcelsList(parcelsList, errorsList)
      case "INITIAL":
      default:
        return null
    }
  }
}

const mapStateToProps = state => ({
  state: state.parcels.state,
  parcelsList: state.parcels.list,
  errorsList: state.parcels.errors,
})

const mapDispatchToProps = dispatch => ({
  get: parcels => dispatch({
    type: GET_PARCELS,
    parcels,
  }),
  clear: () => dispatch(clearParcels()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Parcels)



// WEBPACK FOOTER //
// ./src/views/Parcels/Parcels.js